import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config.js";
import sortByParam from "../../hooks/SortByParam";
import sarchInTheTable from "../../hooks/SarchInTable";
import filterBy from "../../hooks/FilterBy";
import FeatureForm from "./FeatureForm";
import FeaturesTable from "./FeaturesTable";
import FeatureSearch from "./FeatureSearch";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";
import SubTitle from "../../components/common/SubTitle";
import Footer from "../../components/common/Footer.jsx";

/**
 * This function calls an api to return the list of features
 * @returns List<Feature>
 */
async function getAllFeature() {
  try {
    const response = await axios.get(`${config.baseURL}/feature`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching features:", error);
    throw error;
  }
}

/**
 * calls an api to delete the feature from the backend
 * @param {int} id
 * @returns responseObjet-> message,feature
 */
async function deleteFeature(id) {
  try {
    const response = await axios.delete(`${config.baseURL}/feature/${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

/**
 *
 * @param {name:string,
 * description:string,
 * api_path:string,
 * action:string} feture
 * @returns
 */
async function createFeature(feture) {
  try {
    const response = await axios.post(`${config.baseURL}/feature`, feture, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function updateFeature(feature, id) {
  try {
    const response = await axios.put(
      `${config.baseURL}/feature/${id}`,
      feature,
      {
        withCredentials: true,
      },
    );
    return response.data.feature;
  } catch (error) {
    throw error;
  }
}

const Feature = () => {
  const [featuresList, setFeaturesList] = useState([]);
  const [currentTableData, setCurrentTableData] = useState([]);
  const [searchStr, setSearchStr] = useState("");
  const [apiPath, setApiPath] = useState("");
  const [operation, setOperation] = useState("");
  const [sortParam, setSortParam] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");

  // onChange for searching
  const handleSearchChange = (e) => {
    const searchText = e.target.value.toLowerCase(); // Convert search text to lowercase
    // console.log("Search Text:", searchText); // Log search text
    setSearchStr(searchText); // Update search string state
  };

  // on change for filtering by api_path
  const handleApiPathChange = (e) => {
    const selectedValue = e.target.value;
    // console.log("Selected API Path:", selectedValue); // Log selected value
    // If "All" is selected, set apiPath state to an empty string to remove the filter
    // Otherwise, set it to the selected value
    setApiPath(selectedValue === "All" ? "" : selectedValue);
  };

  // on change for filtering  by operation
  const handleOperationChange = (e) => {
    const selectedValue = e.target.value;
    // console.log("Selected operation:", selectedValue); // Log selected value
    // If "All" is selected, set operation state to an empty string to remove the filter
    // Otherwise, set it to the selected value
    setOperation(selectedValue === "All" ? "" : selectedValue);
  };
  const handleSortChange = (param) => {
    // If the currently sorted parameter is the same as the clicked one, toggle direction
    const newSortDirection =
      sortParam === param ? (sortDirection === "asc" ? "desc" : "asc") : "asc";
    setSortDirection(newSortDirection);
    setSortParam(param);
  };

  useEffect(() => {
    getAllFeature()
      .then((features) => {
        setFeaturesList(features);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    let nextTableData = [...featuresList];

    if (searchStr) {
      nextTableData = sarchInTheTable(searchStr, nextTableData);
    }

    if (apiPath) {
      nextTableData = filterBy("api_path", apiPath, nextTableData);
    }

    if (operation) {
      nextTableData = filterBy("action", operation, nextTableData);
    }

    nextTableData = sortByParam(sortParam, nextTableData);
    if (sortDirection === "desc") {
      nextTableData = nextTableData.reverse();
    }

    setCurrentTableData(nextTableData);
  }, [apiPath, featuresList, operation, searchStr, sortDirection, sortParam]);

  function addFeature(feature) {
    if (!feature?.feature) {
      return;
    }

    setFeaturesList((prevList) => [...prevList, feature.feature]);
  }

  async function handleDeleteFeature(id) {
    const response = await deleteFeature(id);
    setFeaturesList((prevList) =>
      prevList.filter((feature) => feature.id !== id),
    );
    return response;
  }

  async function handleUpdateFeature(feature, id) {
    const updatedFeature = await updateFeature(feature, id);
    setFeaturesList((prevList) =>
      prevList.map((item) =>
        item.id === id ? { ...item, ...updatedFeature } : item,
      ),
    );
    return updatedFeature;
  }

  // deleteFeature(2).
  //   then(response => console.log(response)).catch(error => console.log(error))
  // updateFeature({
  //   "name": "get all users",
  //   "description": "this feature allow the user to git list of organization",
  //   "api_path": "/api/user/",
  //   "action": "DELETE"
  // },3).then(response => console.log(response)).catch(error => console.log(error));

  const orgSubtitleName = JSON.parse(localStorage.getItem("userState"))
    ?.organization?.name;

  return (
    <>
      {/* <DashboardHeader title="Features"/> */}
      {/* New design */}
      <TitleBar />
      <NavMenu />
      <SubTitle
        title="Features"
        path={`${orgSubtitleName} > Features`}
        addPath={featuresList.length}
      />
      <div
        //  className='page_container'
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px 0",
          boxSizing: "border-box",
        }}
      >
        <FeatureForm createFeature={createFeature} addFeature={addFeature} />
        <div
          style={{
            margin: "40px",
            padding: "40px 20px",
            width: "calc(100% - 80px)",
            boxSizing: "border-box",
            borderRadius: 10,
            borderWidth: 1,
            gap: 32,
            background: "#FFFFFF",
            border: "1px solid #A5DCF3",
            boxShadow: "-2px 2px 5px 0px #00000040",
          }}
        >
          <FeatureSearch
            featuresList={featuresList}
            handleSearchChange={handleSearchChange}
            handleApiPathChange={handleApiPathChange}
            handleOperationChange={handleOperationChange}
          />
          <FeaturesTable
            featuresList={currentTableData}
            onDelete={handleDeleteFeature}
            onUpdate={handleUpdateFeature}
            onSortChange={handleSortChange}
            sortParam={sortParam}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Feature;
